
import { Browse } from "@/models/browse";
import { View } from "@/models/view";
import { BrowseService } from "@/services/browse-service";
import { getModel, Model } from "@/utils/models/model";
import { ViewTotal } from "@/utils/views/view-total";
import Vue from "vue";
import AppTotalEditColumn from "./TotalEdit.vue";

export default Vue.extend({
	data(){
		return {
			browses: [] as Browse[],
			toEditTotal: null as null | ViewTotal,
			toEditTotalIndex: -1
		};
	},
	props: {
		view: {
			type: Object as ()=>View,
			required: true
		}
	},
	computed: {
		browse(): Browse | undefined {
			return this.browses.find((b: Browse) => b.ID == this.view.BrowseID);
		},
		model():Model {
			return getModel(this.view.Table);
		}
	},
	methods: {
		addTotal(){
			this.toEditTotal = new ViewTotal();
			this.toEditTotalIndex = -1;
		},
		editTotal(i:number){
			this.toEditTotal = new ViewTotal(this.view.Totals[i].getJSON(this.model));
			this.toEditTotalIndex = i;
		},
		removeTotal(i:number){
			this.view.Totals.splice(i, 1);
		},
		closeEdit(){
			this.toEditTotal = null;
			this.toEditTotalIndex = -1;
		},
		saveEdit(){
			if (!this.toEditTotal) return;
			if (this.toEditTotalIndex == -1){
				this.view.Totals.push(this.toEditTotal);
			}else{
				this.view.Totals[this.toEditTotalIndex] = this.toEditTotal;
			}
			this.toEditTotal = null;
			this.toEditTotalIndex = -1;
		}
	},
	async created(){
		this.browses = await BrowseService.getBrowses();
	},
	components: {
		AppTotalEditColumn
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
